import { IPermitFormState } from 'types/permits.interface'
import { IPermitTypeFormState } from 'types/permitTypes.interface'

export const permitStatuses = [
  { label: 'Draft', value: 1, color: '#8A8A8A' },
  { label: 'Active', value: 2, color: '#24D07B' },
  { label: 'Suspended', value: 3, color: '#F4D03F' },
  { label: 'Closed', value: 4, color: '#6B8A6B' },
  { label: 'Revoked', value: 5, color: '#E74C3C' },
]

export const zoneScopeLevels = [
  { label: 'Zone', value: 1 },
  { label: 'Section', value: 2 },
  { label: 'Block', value: 3 },
  { label: 'Pit', value: 4 },
]

export const zoneLevelToApi: Record<number, string> = {
  1: 'ZONE',
  2: 'SECTION',
  3: 'BLOCK',
  4: 'PIT',
}

export const apiLevelToZoneValue: Record<string, number> = {
  ZONE: 1,
  SECTION: 2,
  BLOCK: 3,
  PIT: 4,
}

export const DEFAULT_PERMIT_FORM: IPermitFormState = {
  permitType: null,
  holderUserIds: [],
  zoneScopeLevel: null,
  zoneScopes: [],
  expiresAt: null,
}

export const DEFAULT_PERMIT_TYPE_FORM: IPermitTypeFormState = {
  code: null,
  name: null,
  requiresCoPresence: false,
  minHolders: null,
  requiredCapabilities: [],
}
